import React from "react";
import { PageCardsContainer } from "./style";
import { Card } from "./Card";
import { cardsInfo, hiddenPages } from "@constants/pages";

export const PagesCard = () => {
  return (
    <PageCardsContainer>
      {cardsInfo.map((cardInfo) => {
        if (hiddenPages.includes(cardInfo.link)) return null;

        return (
          <Card
            key={cardInfo.title}
            title={cardInfo.title}
            subtitle={cardInfo.subtitle}
            icon={cardInfo.icon}
            link={cardInfo.link}
          />
        );
      })}
    </PageCardsContainer>
  );
};
